module.exports = __webpack_public_path__ + "static/img/s6.08d3a96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s6.png
// module id = ijGy
// module chunks = 1